export type ItemProps = {
  id: number;
  label: string;
  description?: string;
  url: string;
  isEmail?: boolean;
};

export type MenuItemProps = {
  id: number;
  label: string;
  url: string;
  items?: ItemProps[];
};

export type SiteProps = {
  id: number;
  label: string;
  available: boolean;
  url: string;
  current?: boolean;
};

export const allSites: SiteProps[] = [
  {
    id: 1,
    label: "Main Gateway",
    available: true,
    url: "https://g2aging.org",
  },
  { id: 2, label: "COVID", available: true, url: "https://covid.g2aging.org" },
  {
    id: 3,
    label: "Exposome",
    available: true,
    url: "https://exposome.g2aging.org",
  },
  {
    id: 4,
    label: "End of Life",
    available: true,
    url: "https://eol.g2aging.org",
  },
  { id: 5, label: "HCAP", available: true, url: "https://hcap.g2aging.org", current: true },
  { id: 6, label: "Life History", available: false, url: "" },
  {
    id: 7,
    label: "Data Enclave",
    available: true,
    url: "https://g2aging.org/enclave",
  },
];

export const headerItems: MenuItemProps[] = [
  { id: 1, label: "Getting Started", url: "/getting-started" },
  {
    id: 2,
    label: "HCAP Studies",
    url: "/hcap-studies",
    items: [
      {
        id: 21,
        label: "Overview",
        description: "Find information about each study with an HCAP interview cataloged by the Gateway",
        url: "/hcap-studies/overview",
      },
      {
        id: 22,
        label: "Questionnaires",
        description: "View survey questionnaires",
        url: "/hcap-studies/questionnaire",
      },
      {
        id: 23,
        label: "Search",
        description: "Search through survey questionnaires",
        url: "/hcap-studies/search",
      },
      {
        id: 24,
        label: "Question Concordance",
        description: "See comparability of survey questions across studies and over time for selected topics",
        url: "/hcap-studies/question-concordance",
      },
      {
        id: 25,
        label: "Get Data",
        description: "Links to download survey data",
        url: "/hcap-studies/get-data",
      },
    ],
  },
  {
    id: 3,
    label: "Harmonized HCAP Data",
    url: "/harmonized-hcap-data",

    items: [
      {
        id: 31,
        label: "Overview",
        description: "Find information about each Harmonized dataset",
        url: "/harmonized-hcap-data/overview",
      },
      {
        id: 32,
        label: "Search",
        description: "Search for Harmonized variables",
        url: "/harmonized-hcap-data/search",
      },
      {
        id: 33,
        label: "Variable Concordance",
        description: "Find and compare Harmonized variables across datasets",
        url: "/harmonized-hcap-data/variable-concordance",
      },
      {
        id: 34,
        label: "Get Data",
        description: "Links to download Harmonized data",
        url: "/harmonized-hcap-data/get-data",
      },
    ],
  },
  {
    id: 4,
    label: "Additional HCAP Resources",
    url: "/additional-hcap-resources",
    items: [
      {
        id: 41,
        label: "Recommendations for using HCAP",
        description: " Get information on best practices for data analysis using HCAP data",
        url: "/additional-hcap-resources/recommendations",
      },
      {
        id: 42,
        label: "Methodological Information",
        description: " Get information on best practices for data analysis using HCAP data",
        url: "/additional-hcap-resources/methodological-information",
      },
      {
        id: 43,
        label: "HCAP Publications",
        description: "Search publications based on HCAP surveys around the world",
        url: "/additional-hcap-resources/publications",
      },
      {
        id: 44,
        label: "HCAP Webinars & Presentations",
        description: "Find upcoming and past HCAP webinars and presentations on a variety of helpful topics",
        url: "/additional-hcap-resources/webinars-and-presentations",
      },
    ],
  },
];

export const footerItems: MenuItemProps[] = [
  {
    id: 1,
    label: "Quick Links",
    url: "/",
    items: [
      {
        id: 11,
        label: "Study Overview",
        url: "/hcap-studies/overview",
      },
      {
        id: 12,
        label: "Harmonized Data Overview",
        url: "/harmonized-hcap-data/overview",
      },
    ],
  },
  {
    id: 2,
    label: "Help and Support",
    url: "/",
    items: [
      {
        id: 21,
        label: "HCAP Publications",
        url: "/additional-hcap-resources/publications",
      },
      {
        id: 22,
        label: "Methodological Information",
        url: "/additional-hcap-resources/methodological-information",
      },
      {
        id: 23,
        label: "Recommendations for using HCAP",
        url: "/additional-hcap-resources/recommendations",
      },
      {
        id: 24,
        label: "Help Desk",
        url: "mailto:help@g2aging.org",
        isEmail: true,
      },
    ],
  },
];
